// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Eb1C6","truncatedText":"styles_truncatedText__QVOj1","fullText":"styles_fullText__Ra_tP","textContainer":"styles_textContainer__q_Su_"};